import { CSSProperties, type ReactNode } from "react";

import { AspectRatios } from "../../image/src/index";

export type VidTypes = "mp4" | "mpeg" | "ogg" | "webm";

export interface AltSourceProps {
    videoLink: string;
    videoType?: VidTypes;
}

export interface VideoProps {
    videoLink: string;
    videoType?: VidTypes;
    videoPreviewImage?: string;
    loop?: boolean;
    muted?: boolean;
    aspectRatio?: AspectRatios;
    alternativeSources?: AltSourceProps[];
    className?: string;
    fallbackText?: string;
    children?: ReactNode;
}

const videoStyle = (ratio?: AspectRatios) => {
    const aspectRatioCSS =
        ratio && ratio !== "none"
            ? { aspectRatio: ratio, objectFit: "cover" }
            : {};
    return { maxWidth: "100%", ...aspectRatioCSS };
};

export const Video = ({
    videoLink,
    videoType,
    videoPreviewImage,
    loop = true,
    muted = true,
    aspectRatio,
    alternativeSources,
    className,
    fallbackText,
    children
}: VideoProps) => {
    return (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video
            playsInline={true}
            muted={muted}
            preload="auto"
            poster={videoPreviewImage}
            autoPlay={true}
            className={className}
            style={videoStyle(aspectRatio) as CSSProperties}
            loop={loop}
        >
            {fallbackText}
            <source
                src={videoLink}
                type={`video/${videoType ? videoType : "mp4"}`}
            />
            {alternativeSources
                ? alternativeSources.map((source: AltSourceProps, index) => {
                      return (
                          <source
                              key={index}
                              src={source.videoLink}
                              type={`video/${
                                  source.videoType ? source.videoType : "mp4"
                              }`}
                          />
                      );
                  })
                : null}
            {children}
        </video>
    );
};
